import { LOADING_CONTEXT } from '@/contexts/Loading';
import { useContext } from 'react';

export const Overlay = () => {
  const { isOverlay, overlay } =
    useContext(LOADING_CONTEXT);
  const zIndex = 1;

  if (!isOverlay) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 24,
          textAlign: 'center',
        }}
      >
        {overlay && (
          <div
            style={{
              color: '#ffffff',
              fontWeight: 'bold',
              fontSize: '1.25rem',
            }}
          >
            {overlay}
          </div>
        )}

        <span
          aria-label="loading"
          style={{
            width: 40,
            height: 40,
            border: '4px solid rgba(255,255,255,0.3)',
            borderTopColor: '#ffffff',
            borderRadius: '50%',
            animation: 'overlay-spin 0.9s linear infinite',
          }}
        />
      </div>

      <style>
        {`
          @keyframes overlay-spin {
            to {
              transform: rotate(360deg);
            }
          }
        `}
      </style>
    </div>
  );
};
